// TODO: must be refactored
// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// MUI components
import Box from '@mui/material/Box';
// import Container from "@mui/material/Container";

import MansionsList from './MansionsList';

// Section for type definition -----------------------------------------------------------------------------------------

export default function MansionsSelector(props: any) {
  const { prefecturesData } = props;
  const { mansionsData } = props;

  // Section for render component --------------------------------------------------------------------------------------
  return (
    // Section for render Mobile mode ----------------------------------------------------------------------------------
    <Box>
      <MansionsList prefecturesData={prefecturesData} modePrefSelect="prefectures" mansionsData={mansionsData} />
    </Box>
  );
}
